import React from 'react'
import {cssOnlyDesktop, cssOnlyMobile} from "../styles/utils";

export const DesktopBr = () => {
  return <br css={[cssOnlyMobile('display:none')]}/>
}

export const MobileBr = () => {
  return <br css={[cssOnlyDesktop('display:none')]}/>
}
